import React from "react";
import { StyledTitle } from "./style";

const Title = ({ children, weight, italic = false, highlight = false }) => {
  return (
    <StyledTitle weight={weight} italic={italic} highlight={highlight}>
      {children}
    </StyledTitle>
  );
};

export default Title;
